"use client";
import * as React from "react";
const SvgFileUploadRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M2.729 6.357h1.476v4.821c0 .53.418.965.929.965h3.714c.51 0 .928-.434.928-.965v-4.82h1.477c.826 0 1.244-1.042.66-1.65L7.65.282a.9.9 0 0 0-1.31 0L2.08 4.708c-.585.608-.177 1.65.65 1.65ZM.5 15.036c0 .53.418.964.929.964H12.57c.511 0 .929-.434.929-.964s-.418-.965-.929-.965H1.43c-.511 0-.929.434-.929.965Z" }));
export {
  SvgFileUploadRound as default
};
